import React, { useState, useEffect } from "react";
import List from "./List";
import Alert from "./Alert";

function App() {
  const [item, setItem] = useState("");
  const [itemId, setItemId] = useState(0);
  const [groceries, setGroceries] = useState([]);
  const [buttonText, setButtonText] = useState("Submit");
  const [alert, setAlert] = useState({ show: false, msg: "", type: "" });

  // ADDS
  function handleSubmit(e) {
    e.preventDefault();

    if (buttonText === "Edit") {
      setAlert({ ...alert, show: true, msg: "Item has been updated", type: "alert alert-success" });
      updateItem();
    } else {
      let userInput = document.getElementById("userInput");
      userInput.value = "";

      setAlert({ ...alert, show: true, msg: "item added to the list", type: "alert alert-success" });
      setGroceries([...groceries, item]);
    }
    setButtonText("Submit");
  }

  const editItem = (item, index) => {
    setButtonText("Edit");
    setItemId(index);
  };

  //UPDATES
  const updateItem = () => {
    let newGroceries = groceries.map((oldItem, index) => {
      if (index === itemId) {
        return item;
      } else {
        return oldItem;
      }
    });

    setGroceries(newGroceries);
  };

  // DELETES
  const deleteItem = (itemIndex) => {
    setGroceries(groceries.filter((grocery, index) => index !== itemIndex));
    setAlert({ ...alert, show: true, msg: "Item deleted", type: "alert alert-danger" });
  };

  const handleClear = () => {
    setGroceries([]);
    setAlert({ ...alert, show: true, msg: "All items have been cleared", type: "alert alert-danger" });
  };

  return (
    <section className="section-center">
      <Alert alert={alert}></Alert>
      <form className="grocery-form" onSubmit={handleSubmit}>
        <h3>Grocery Bud</h3>
        <div className="form-control">
          <input
            className="grocery"
            placeholder="e.g. eggs"
            type="text"
            name="userInput"
            id="userInput"
            onChange={(e) => setItem(e.target.value)}
          />

          <button type="submit" className="submit-btn" onClick={handleSubmit}>
            {buttonText}
          </button>
        </div>
      </form>
      <br />
      <List groceries={groceries} editItem={editItem} deleteItem={deleteItem}></List>
      <div className="btn-container">
        {groceries.length <= 0 || (
          <span className="clear-btn" onClick={handleClear}>
            Clear Items
          </span>
        )}
      </div>
    </section>
  );
}

export default App;
